import { useState } from 'react';
import useTrashStore from 'src/store/api/useTrashStore';
 
const useRestoreFolder = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const restoreFolder = async (folderId: string) => {
    setIsProcessing(true);
    setError(null);
    setSuccessMessage(null);
    try {
      await useTrashStore.getState().restoreFolder(folderId);
      const state = useTrashStore.getState();
      setSuccessMessage(state.responseMessage);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    restoreFolder,
    isProcessing,
    error,
    successMessage,
  };
};

export default useRestoreFolder;
